import {CareTaskInfo} from '../../utils/data/care-task-info';

export type UserFilters = {
  socialResponses?: string[];
  taskStatus?: TaskStatus[];
  activeStatus?: boolean[];
  shifts?: string[];
  patientOccurrences?: string[];
  generalOccurrences?: string[];
  badl?: string[];
  iadl?: string[];
  clinicalSupport?: string[];
  personalDevelopment?: string[];
};

export type TaskStatus = 'planned' | 'handled' | 'done' | 'not_done' | 'not_handled' | 'registered';

export type UserFilterTypes = keyof UserFilters;

/**
 * Create filters from `<UsersFilter />` string output.
 */
export function createUsersFilters(rawFilters: string | undefined): UserFilters {
  // ------- No filters -------
  if (!rawFilters) {
    return {};
  }

  // ------- Parse filters -------
  const filtersArray = rawFilters.split('&');
  const result: UserFilters = {};

  for (const filter of filtersArray) {
    const [key, value] = filter.split('=');
    switch (key) {
      case 'activationStates':
        if (!result.activeStatus) result.activeStatus = [];
        result.activeStatus.push(value.toLowerCase() === 'true');
        break;

      case 'taskStatus':
        if (!result.taskStatus) result.taskStatus = [];
        result.taskStatus.push(value as TaskStatus);
        break;

      case 'socialResponsesIds':
        if (!result.socialResponses) result.socialResponses = [];
        result.socialResponses.push(value);
        break;

      case 'shifts':
        if (!result.shifts) result.shifts = [];
        result.shifts.push(value);
        break;

      case 'patientOccurrences':
        if (!result.patientOccurrences) result.patientOccurrences = [];
        result.patientOccurrences.push(value);
        break;

      case 'generalOccurrences':
        if (!result.generalOccurrences) result.generalOccurrences = [];
        result.generalOccurrences.push(value);
        break;

      case 'badl':
        if (!result.badl) result.badl = [];
        result.badl.push(value);
        break;

      case 'iadl':
        if (!result.iadl) result.iadl = [];
        result.iadl.push(value);
        break;

      case 'clinicalSupport':
        if (!result.clinicalSupport) result.clinicalSupport = [];
        result.clinicalSupport.push(value);
        break;

      case 'personalDevelopment':
        if (!result.personalDevelopment) result.personalDevelopment = [];
        result.personalDevelopment.push(value);
        break;

      default:
        // Do nothing
        console.warn('Unknown filter key:', key);
        break;
    }
  }

  // ------- Filters -------
  return result;
}

/**
 * Filter the care task by its status.
 */
export function filterCareTaskInfoByStatus(cti: CareTaskInfo, status: TaskStatus): boolean {
  switch (status) {
    case 'planned':
      return !cti.unattended && !cti.handled;
    case 'handled':
      return cti.handled;
    case 'not_done':
      return cti.done === false;
    case 'done':
      return cti.done === true;
    case 'not_handled':
      return cti.unattended;
    default:
      return true;
  }
}
